// extracted by mini-css-extract-plugin
export default {"WetPrinting":"style_WetPrinting__pimcl"};